import React, { Component } from "react";
import Translate, { reactTranslateChangeLanguage } from "translate-components";
import '../Forge/style.css'
import Advantages from "../../Basic/TrustBlocks/Advantages";
import LogoRed from '../../DynamicContent/About/dsideLogo.svg';
import Bill from '../Forge/dside-bill.svg';
import Receipt from '../Forge/dside-receipt.svg';
import Footer from '../../Basic/Footer/index';
import About from '../../DynamicContent/Main/About__block/index';

class PaymentTypes extends Component {
    constructor() {
        super();

        this.state = {};
    }
  componentDidMount(){
  this.setState({lang: localStorage.getItem('lang')});
  }

  render(){

let newDate = new Date();
let options = { month: 'short' };
let today = new Intl.DateTimeFormat(this.state.lang, options).format(newDate.getFullDate);
var dateValue = newDate.getDate() + 31;
var dateValue2 = newDate.getDate() + 31;
var dateValue3 = newDate.getDate() + 31;
newDate.setDate(dateValue);
let tomorrow = new Intl.DateTimeFormat(this.state.lang, options).format(newDate);
newDate.setDate(dateValue2);
let tomo = new Intl.DateTimeFormat(this.state.lang, options).format(newDate);
newDate.setDate(dateValue3);
let tomo2 = new Intl.DateTimeFormat(this.state.lang, options).format(newDate);
    return (
     <div className="forgepage">
      <div className="payments-intro">
        <div className="row">
            <h2><span><img className="logo-forge-intro" src={LogoRed} width={130}/> Payments</span></h2>
        </div>
      </div>
      <div className="forge-short-descr">
        <div className="row">
            <div className="shortdescr">
            <h4><Translate>About our payment methods</Translate></h4>
            <p><Translate>For your convenience, we have developed three innovative payment solutions:</Translate></p>
            </div>
        </div>
      </div>
      <div className="forge-item-descr">
        <div className="row">
            <div className="item-descr-tl">
<img className="img-timeline" src={Bill} />

            <div className="timeline-descr">
                <h4><Translate>One-time payment</Translate></h4>
                <p><Translate>You pay with a one-time payment and your project is processed immediately. The rights to use intellectual property are entirely yours for lifetime.</Translate></p>
            </div>
            </div>
        </div>
      </div><div className="forge-item-descr ">
        <div className="row">
            <div className="item-descr-tl item-reverse">
<svg className="img-timeline" viewBox="0 0 400 384.8"  >
<g id="XMLID_118_">
	<g id="XMLID_129_">
		<g id="XMLID_131_">
			<g id="XMLID_244_">
                <g id="XMLID_279_">
			<rect id="XMLID_98_" x="15.6" y="121.2" className="bl10" width="361.9" height="158.3"/>
		</g>
				<path id="XMLID_249_" className="bl0" d="M344.9,270h3c6.4-1.7,13-3.3,20-4.4v-0.8C359.7,266.1,352.2,267.9,344.9,270z"/>
			</g>
			<g id="XMLID_235_">
				<path id="XMLID_273_" className="bl0" d="M51.1,270c2.8-0.9,5.5-1.8,8.3-2.7c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8
					V256c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3c-3.4,1.1-6.8,2.2-10.2,3.3H51.1z"/>
				<path id="XMLID_272_" className="bl0" d="M199.9,270h2.6c-3.4-1.1-6.8-2.2-10.2-3.3c-11.8-3.9-23.9-7.8-37.2-10.4v0.8
					c13,2.6,24.9,6.5,36.5,10.3C194.3,268.2,197.1,269.1,199.9,270z"/>
				<path id="XMLID_275_" className="bl0" d="M324.5,266.6c-3.4,1.1-6.8,2.2-10.2,3.3h2.6c2.8-0.9,5.5-1.8,8.3-2.7
					c13.4-4.4,27.2-8.9,42.6-11.4v-0.8C352.1,257.6,338.1,262.2,324.5,266.6z"/>
			</g>
			<g id="XMLID_228_">
				<path id="XMLID_279_" className="bl0" d="M34.8,270c8.5-2.2,16.6-4.9,24.6-7.5c19.8-6.5,40.4-13.2,66.1-13.2
					c10.3,0,19.7,1.1,28.6,2.8v-0.8c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3c-8.7,2.9-17.7,5.8-27,8.1H34.8z"/>
				<path id="XMLID_271_" className="bl0" d="M216.2,270h3.1c-9.4-2.4-18.3-5.3-27-8.1c-11.8-3.9-23.9-7.8-37.2-10.4v0.8
					c13,2.6,24.9,6.5,36.5,10.3C199.6,265.1,207.7,267.7,216.2,270z"/>
				<path id="XMLID_294_" className="bl0" d="M324.5,261.8c-8.7,2.9-17.6,5.8-27,8.1h3.1c8.5-2.2,16.6-4.9,24.6-7.5
					c13.4-4.4,27.2-8.9,42.6-11.4v-0.8C352.1,252.8,338.1,257.3,324.5,261.8z"/>
			</g>
			<g id="XMLID_226_">
				<path id="XMLID_283_" className="bl0" d="M241.3,270h8.4c-21.8-1.3-39.9-7.2-57.5-13c-11.8-3.9-23.9-7.8-37.2-10.4v0.8
					c13,2.6,24.9,6.5,36.5,10.3C207,262.7,222.9,267.9,241.3,270z"/>
				<path id="XMLID_340_" className="bl0" d="M324.5,257c-17.6,5.8-35.7,11.7-57.5,13h8.4c18.5-2.1,34.3-7.3,49.7-12.4
					c13.4-4.4,27.2-8.9,42.6-11.4v-0.8C352.1,247.9,338.1,252.5,324.5,257z"/>
				<path id="XMLID_298_" className="bl0" d="M154,246.4c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V246.4
					z"/>
			</g>
			<g id="XMLID_222_">
				<path id="XMLID_269_" className="bl0" d="M154,241.5c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V241.5
					z"/>
				<path id="XMLID_270_" className="bl0" d="M367.8,240.6c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V240.6z"/>
			</g>
			<g id="XMLID_217_">
				<path id="XMLID_260_" className="bl0" d="M154,236.7c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V236.7
					z"/>
				<path id="XMLID_289_" className="bl0" d="M367.8,235.8c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V235.8z"/>
			</g>
			<g id="XMLID_213_">
				<path id="XMLID_256_" className="bl0" d="M154,231.8c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V231.8
					z"/>
				<path id="XMLID_295_" className="bl0" d="M367.8,231c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V231z"/>
			</g>
			<g id="XMLID_211_">
				<path id="XMLID_252_" className="bl0" d="M154,227c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V227z"
					/>
				<path id="XMLID_297_" className="bl0" d="M367.8,226.1c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V226.1z"/>
			</g>
			<g id="XMLID_209_">
				<path id="XMLID_301_" className="bl0" d="M367.8,221.3c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V221.3z"/>
				<path id="XMLID_303_" className="bl0" d="M154,222.2c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V222.2
					z"/>
			</g>
			<g id="XMLID_207_">
				<path id="XMLID_242_" className="bl0" d="M154,217.3c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V217.3
					z"/>
				<path id="XMLID_248_" className="bl0" d="M367.8,216.5c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V216.5z"/>
			</g>
			<g id="XMLID_205_">
				<path id="XMLID_240_" className="bl0" d="M154,212.5c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V212.5
					z"/>
				<path id="XMLID_304_" className="bl0" d="M367.8,211.6c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V211.6z"/>
			</g>
			<g id="XMLID_203_">
				<path id="XMLID_236_" className="bl0" d="M154,207.7c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V207.7
					z"/>
				<path id="XMLID_305_" className="bl0" d="M367.8,206.8c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V206.8z"/>
			</g>
			<g id="XMLID_201_">
				<path id="XMLID_231_" className="bl0" d="M154,202.8c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V202.8
					z"/>
				<path id="XMLID_306_" className="bl0" d="M367.8,202c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V202z"/>
			</g>
			<g id="XMLID_198_">
				<path id="XMLID_307_" className="bl0" d="M367.8,197.1c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V197.1z"/>
				<path id="XMLID_308_" className="bl0" d="M154,198c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V198z"
					/>
			</g>
			<g id="XMLID_196_">
				<path id="XMLID_223_" className="bl0" d="M154,193.2c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V193.2
					z"/>
				<path id="XMLID_227_" className="bl0" d="M367.8,192.3c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V192.3z"/>
			</g>
			<g id="XMLID_194_">
				<path id="XMLID_221_" className="bl0" d="M154,188.3c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V188.3
					z"/>
				<path id="XMLID_330_" className="bl0" d="M367.8,187.5c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V187.5z"/>
			</g>
			<g id="XMLID_192_">
				<path id="XMLID_214_" className="bl0" d="M154,183.5c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V183.5
					z"/>
				<path id="XMLID_310_" className="bl0" d="M367.8,182.6c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V182.6z"/>
			</g>
			<g id="XMLID_190_">
				<path id="XMLID_212_" className="bl0" d="M154,178.7c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V178.7
					z"/>
				<path id="XMLID_311_" className="bl0" d="M367.8,177.8c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V177.8z"/>
			</g>
			<g id="XMLID_188_">
				<path id="XMLID_312_" className="bl0" d="M367.8,172.9c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V172.9z"/>
				<path id="XMLID_313_" className="bl0" d="M154,173.8c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V173.8
					z"/>
			</g>
			<g id="XMLID_186_">
				<path id="XMLID_208_" className="bl0" d="M154,169c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V169z"
					/>
				<path id="XMLID_334_" className="bl0" d="M367.8,168.1c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V168.1z"/>
			</g>
			<g id="XMLID_183_">
				<path id="XMLID_314_" className="bl0" d="M367.8,163.3c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V163.3z"/>
				<path id="XMLID_315_" className="bl0" d="M154,164.2c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6L26,185c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V164.2z
					"/>
			</g>
			<g id="XMLID_181_">
				<path id="XMLID_204_" className="bl0" d="M154,159.3c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V159.3
					z"/>
				<path id="XMLID_206_" className="bl0" d="M367.8,158.4c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V158.4z"/>
			</g>
			<g id="XMLID_179_">
				<path id="XMLID_202_" className="bl0" d="M154,154.5c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V154.5
					z"/>
				<path id="XMLID_316_" className="bl0" d="M367.8,153.6c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V153.6z"/>
			</g>
			<g id="XMLID_177_">
				<path id="XMLID_199_" className="bl0" d="M154,149.6c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V149.6
					z"/>
				<path id="XMLID_317_" className="bl0" d="M367.8,148.8c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V148.8z"/>
			</g>
			<g id="XMLID_175_">
				<path id="XMLID_197_" className="bl0" d="M154,144.8c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V144.8
					z"/>
				<path id="XMLID_339_" className="bl0" d="M367.8,143.9c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V143.9z"/>
			</g>
			<g id="XMLID_173_">
				<path id="XMLID_195_" className="bl0" d="M154,140c-8.9-1.7-18.3-2.7-28.6-2.7c-26.1,0-46.8,6.8-66.8,13.3
					c-10.6,3.5-21.5,7.1-33.1,9.6l0.5,0.7c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c10.3,0,19.7,1.1,28.6,2.8V140z"
					/>
				<path id="XMLID_319_" className="bl0" d="M367.8,139.1c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-11.8-3.9-23.9-7.8-37.2-10.4v0.8c13,2.6,24.9,6.5,36.5,10.3c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V139.1z"/>
			</g>
			<g id="XMLID_171_">
				<path id="XMLID_320_" className="bl0" d="M367.8,134.3c-15.8,2.5-29.7,7-43.3,11.5c-19.8,6.5-40.4,13.2-66.1,13.2
					c-25.8,0-46.3-6.7-66.1-13.2c-20-6.6-40.7-13.3-66.8-13.3c-26.1,0-46.8,6.8-66.8,13.3c-10.6,3.5-21.5,7.1-33.1,9.6L26,156
					c11.7-2.5,22.7-6.2,33.3-9.6c19.8-6.5,40.4-13.2,66.1-13.2c25.8,0,46.3,6.7,66.1,13.2c20,6.6,40.7,13.3,66.8,13.3
					c26.1,0,46.8-6.8,66.8-13.3c13.4-4.4,27.2-8.9,42.6-11.4V134.3z"/>
			</g>
			<g id="XMLID_167_">
				<path id="XMLID_169_" className="bl0" d="M258.4,154.9c-26.1,0-46.8-6.8-66.8-13.3c-10.7-3.5-21.7-7.1-33.4-9.6l0.5-0.7
					c11.8,2.6,22.9,6.2,33.6,9.7c19.8,6.5,40.4,13.2,66.1,13.2c25.8,0,46.3-6.7,66.1-13.2c10.7-3.5,21.8-7.1,33.6-9.7l0.5,0.7
					c-11.7,2.5-22.7,6.1-33.4,9.6C305.2,148.1,284.5,154.9,258.4,154.9z"/>
			</g>
			<g id="XMLID_165_">
				<path id="XMLID_166_" className="bl0" d="M26,151.2l-0.5-0.7c11.6-2.5,22.6-6.1,33.1-9.6c10.7-3.5,21.8-7.1,33.6-9.7l0.5,0.7
					C81,134.4,70,138,59.3,141.5C48.7,145,37.7,148.6,26,151.2z"/>
			</g>
			<g id="XMLID_162_">
				<path id="XMLID_163_" className="bl0" d="M258.4,150.1c-26.1,0-46.8-6.8-66.8-13.3c-4.9-1.6-10-3.3-15.1-4.8l0.6-0.6
					c5.1,1.5,10.2,3.2,15.1,4.8c19.8,6.5,40.4,13.2,66.1,13.2c25.8,0,46.3-6.7,66.1-13.2c4.9-1.6,10-3.3,15.1-4.8l0.6,0.6
					c-5.1,1.5-10.2,3.2-15.1,4.8C305.2,143.3,284.5,150.1,258.4,150.1z"/>
			</g>
			<g id="XMLID_159_">
				<path id="XMLID_161_" className="bl0" d="M26,146.4l-0.5-0.7c11.6-2.5,22.5-6.1,33.1-9.6c4.9-1.6,10-3.3,15.1-4.8l0.6,0.6
					c-5.1,1.5-10.2,3.2-15.1,4.8C48.7,140.2,37.7,143.8,26,146.4z"/>
			</g>
			<g id="XMLID_154_">
				<path id="XMLID_156_" className="bl0" d="M258.4,145.2c-26.1,0-46.8-6.8-66.8-13.3l0.7-0.6c19.8,6.5,40.4,13.2,66.1,13.2
					c25.8,0,46.3-6.7,66.1-13.2l0.7,0.6C305.2,138.4,284.5,145.2,258.4,145.2z"/>
			</g>
			<g id="XMLID_149_">
				<path id="XMLID_151_" className="bl0" d="M26,141.5l-0.5-0.7c11.6-2.5,22.5-6.1,33.1-9.6l0.7,0.6C48.7,135.4,37.7,139,26,141.5z"/>
			</g>
			<g id="XMLID_144_">
				<path id="XMLID_147_" className="bl0" d="M258.4,140.4c-20.8,0-37.8-4.3-51.7-8.5l0.6-0.6c13.7,4.2,30.5,8.4,51,8.4
					c20.5,0,37.3-4.3,51-8.4l0.6,0.6C296.1,136.1,279.2,140.4,258.4,140.4z"/>
			</g>
			<g id="XMLID_138_">
				<path id="XMLID_141_" className="bl0" d="M26,136.7l-0.5-0.7c5.6-1.2,11.3-2.7,18-4.8l0.6,0.6C37.4,133.9,31.6,135.5,26,136.7z"/>
			</g>
			<g id="XMLID_133_">
				<path id="XMLID_135_" className="bl0" d="M258.4,135.5c-11,0-21.9-1.2-33.2-3.7l0.5-0.7c11.2,2.4,21.9,3.6,32.8,3.6
					c10.8,0,21.6-1.2,32.8-3.6l0.5,0.7C280.3,134.4,269.4,135.5,258.4,135.5z"/>
			</g>
		</g>
	</g>
	<g id="XMLID_119_">
		<path id="XMLID_264_" className="bl1" d="M361.1,194.2c0-22.9-14.9-41.6-33.2-41.6c-18.4,0-33.2,18.6-33.2,41.6s14.9,41.6,33.2,41.6
			C346.2,235.8,361.1,217.2,361.1,194.2z"/>
		<g id="XMLID_245_">
			<polygon id="XMLID_322_" className="bl2" points="149.3,259 29.1,258.9 25.9,257.3 25.9,258.9 25.9,141.6 25.9,143.2 29.2,141.6 
				149.8,141.7 149.8,130.3 25.9,130.2 24.7,130.2 24.7,131.4 24.6,269.2 24.6,270.4 25.8,270.4 149.3,270.5 			"/>
			<path id="XMLID_323_" className="bl0" d="M367.3,130.4l-217.5-0.2v11.5l153.2,0.1l0-6c0-2.3,1.9-4.2,4.2-4.2l47.5,0
				c2.3,0,4.2,1.9,4.2,4.2l0,6l5.1,0l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5L364,157
				l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6
				l0,0.5l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5
				l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5L364,210l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6
				l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6
				l0,0.5l-3.2,1.6l3.2,1.6l0,0.5L364,244l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5l-3.2,1.6l3.2,1.6l0,0.5
				l-3.2,1.6l-5.1,0l0,6c0,2.3-1.9,4.2-4.2,4.2l-69.4,0c-2.3,0-4.2-1.9-4.2-4.2l0-6L149.8,259v11.5l217.4,0.2l1.2,0l0-1.2l0.1-137.8
				l0-1.2L367.3,130.4z"/>
			<polygon id="XMLID_95_" className="bl2" points="25.9,147 29.2,145.4 25.9,143.8 			"/>
			<polygon id="XMLID_94_" className="bl2" points="25.9,150.8 29.2,149.2 25.9,147.6 			"/>
			<polygon id="XMLID_93_" className="bl2" points="25.9,154.6 29.2,153 25.9,151.4 			"/>
			<polygon id="XMLID_92_" className="bl2" points="25.9,158.4 29.2,156.8 25.9,155.1 			"/>
			<polygon id="XMLID_91_" className="bl2" points="25.9,162.2 29.2,160.5 25.9,158.9 			"/>
			<polygon id="XMLID_90_" className="bl2" points="25.9,165.9 29.2,164.3 25.9,162.7 			"/>
			<polygon id="XMLID_89_" className="bl2" points="25.9,169.7 29.2,168.1 25.9,166.5 			"/>
			<polygon id="XMLID_88_" className="bl2" points="25.9,173.5 29.2,171.9 25.9,170.3 			"/>
			<polygon id="XMLID_87_" className="bl2" points="25.9,177.3 29.2,175.7 25.9,174.1 			"/>
			<polygon id="XMLID_86_" className="bl2" points="25.9,181.1 29.1,179.5 25.9,177.8 			"/>
			<polygon id="XMLID_85_" className="bl2" points="25.9,184.9 29.1,183.2 25.9,181.6 			"/>
			<polygon id="XMLID_84_" className="bl2" points="25.9,188.6 29.1,187 25.9,185.4 			"/>
			<polygon id="XMLID_83_" className="bl2" points="25.9,192.4 29.1,190.8 25.9,189.2 			"/>
			<polygon id="XMLID_82_" className="bl2" points="25.9,196.2 29.1,194.6 25.9,193 			"/>
			<polygon id="XMLID_81_" className="bl2" points="25.9,200 29.1,198.4 25.9,196.8 			"/>
			<polygon id="XMLID_80_" className="bl2" points="25.9,203.8 29.1,202.2 25.9,200.5 			"/>
			<polygon id="XMLID_79_" className="bl2" points="25.9,207.6 29.1,206 25.9,204.3 			"/>
			<polygon id="XMLID_78_" className="bl2" points="25.9,211.4 29.1,209.7 25.9,208.1 			"/>
			<polygon id="XMLID_77_" className="bl2" points="25.9,215.1 29.1,213.5 25.9,211.9 			"/>
			<polygon id="XMLID_76_" className="bl2" points="25.9,218.9 29.1,217.3 25.9,215.7 			"/>
			<polygon id="XMLID_75_" className="bl2" points="25.9,222.7 29.1,221.1 25.9,219.5 			"/>
			<polygon id="XMLID_74_" className="bl2" points="25.9,226.5 29.1,224.9 25.9,223.3 			"/>
			<polygon id="XMLID_73_" className="bl2" points="25.9,230.3 29.1,228.7 25.9,227 			"/>
			<polygon id="XMLID_72_" className="bl2" points="25.9,234.1 29.1,232.4 25.9,230.8 			"/>
			<polygon id="XMLID_71_" className="bl2" points="25.9,237.8 29.1,236.2 25.9,234.6 			"/>
			<polygon id="XMLID_70_" className="bl2" points="25.9,241.6 29.1,240 25.9,238.4 			"/>
			<polygon id="XMLID_69_" className="bl2" points="25.9,245.4 29.1,243.8 25.9,242.2 			"/>
			<polygon id="XMLID_68_" className="bl2" points="25.9,249.2 29.1,247.6 25.9,246 			"/>
			<polygon id="XMLID_67_" className="bl2" points="25.9,253 29.1,251.4 25.9,249.7 			"/>
			<polygon id="XMLID_66_" className="bl2" points="25.9,256.8 29.1,255.1 25.9,253.5 			"/>
		</g>
		<g id="XMLID_229_">
			<g id="XMLID_238_">
				<g id="XMLID_239_">
					<path id="XMLID_114_" className="bl2" d="M84.2,219.1c-10.4,0-18.8-8.4-18.8-18.8c0-10.4,8.4-18.8,18.8-18.8S103,190,103,200.3
						C103,210.7,94.6,219.1,84.2,219.1z M84.2,182.4c-9.9,0-17.9,8-17.9,17.9c0,9.9,8,17.9,17.9,17.9c9.9,0,17.9-8,17.9-17.9
						C102.1,190.5,94.1,182.4,84.2,182.4z"/>
				</g>
			</g>
			<g id="XMLID_232_">
				<g id="XMLID_233_">
					<g id="XMLID_234_">
						<path id="XMLID_113_" className="bl2" d="M84.2,217c-9.2,0-16.7-7.5-16.7-16.7c0-9.2,7.5-16.7,16.7-16.7c9.2,0,16.7,7.5,16.7,16.7
							C100.9,209.5,93.4,217,84.2,217z M84.2,189.2c-6.1,0-11.1,5-11.1,11.1c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1
							C95.3,194.2,90.3,189.2,84.2,189.2z"/>
					</g>
				</g>
			</g>
			<g id="XMLID_230_">
				<path id="XMLID_60_" className="bl2" d="M84.2,190.9c-5.2,0-9.4,4.2-9.4,9.4c0,5.2,4.2,9.4,9.4,9.4c5.2,0,9.4-4.2,9.4-9.4
					C93.6,195.1,89.4,190.9,84.2,190.9z"/>
			</g>
		</g>
		<g id="XMLID_215_">
			<g id="XMLID_224_">
				<g id="XMLID_225_">
					<path id="XMLID_112_" className="bl0" d="M308.7,219.3c-10.4,0-18.8-8.4-18.8-18.8c0-10.4,8.4-18.8,18.8-18.8s18.8,8.4,18.8,18.8
						C327.5,210.8,319,219.3,308.7,219.3z M308.7,182.6c-9.9,0-17.9,8-17.9,17.9c0,9.9,8,17.9,17.9,17.9c9.9,0,17.9-8,17.9-17.9
						C326.6,190.6,318.6,182.6,308.7,182.6z"/>
				</g>
			</g>
			<g id="XMLID_218_">
				<g id="XMLID_219_">
					<g id="XMLID_220_">
						<path id="XMLID_111_" className="bl0" d="M308.7,217.2c-9.2,0-16.7-7.5-16.7-16.7c0-9.2,7.5-16.7,16.7-16.7
							c9.2,0,16.7,7.5,16.7,16.7C325.4,209.7,317.9,217.2,308.7,217.2z M308.7,189.4c-6.1,0-11.1,5-11.1,11.1
							c0,6.1,5,11.1,11.1,11.1c6.1,0,11.1-5,11.1-11.1C319.8,194.4,314.8,189.4,308.7,189.4z"/>
					</g>
				</g>
			</g>
			<g id="XMLID_216_">
				<path id="XMLID_55_" className="bl0" d="M308.7,191.1c-5.2,0-9.4,4.2-9.4,9.4c0,5.2,4.2,9.4,9.4,9.4c5.2,0,9.4-4.2,9.4-9.4
					C318.1,195.3,313.9,191.1,308.7,191.1z"/>
			</g>
		</g>
		<g id="XMLID_200_">
			<polygon id="XMLID_54_" className="bl1" points="40.1,146.4 44.7,146.4 44.7,136.9 37.7,136.9 37.7,139.3 40.1,139.3 			"/>
			<path id="XMLID_110_" className="bl1" d="M58.1,144.3c0.5-0.7,0.8-1.6,0.8-2.7c0-1-0.3-1.9-0.8-2.7c-0.5-0.7-1.3-1.3-2.2-1.7
				c-0.9-0.4-2-0.6-3.2-0.6c-1.2,0-2.3,0.2-3.2,0.6c-0.9,0.4-1.7,1-2.2,1.7c-0.5,0.7-0.8,1.6-0.8,2.7c0,1,0.3,1.9,0.8,2.7
				c0.5,0.7,1.3,1.3,2.2,1.7c0.9,0.4,2,0.6,3.2,0.6c1.2,0,2.3-0.2,3.2-0.6C56.9,145.6,57.6,145,58.1,144.3z M52.7,139.3
				c1.1,0,1.6,0.8,1.6,2.4c0,1.6-0.5,2.4-1.6,2.4c-1.1,0-1.6-0.8-1.6-2.4C51.1,140,51.6,139.3,52.7,139.3z"/>
			<path id="XMLID_51_" className="bl2" d="M52.7,144c1.1,0,1.6-0.8,1.6-2.4c0-1.6-0.5-2.4-1.6-2.4c-1.1,0-1.6,0.8-1.6,2.4
				C51.1,143.2,51.6,144,52.7,144z"/>
			<path id="XMLID_109_" className="bl1" d="M72.1,144.3c0.5-0.7,0.8-1.6,0.8-2.7c0-1-0.3-1.9-0.8-2.7c-0.5-0.7-1.3-1.3-2.2-1.7
				c-0.9-0.4-2-0.6-3.2-0.6c-1.2,0-2.3,0.2-3.2,0.6c-0.9,0.4-1.7,1-2.2,1.7c-0.5,0.7-0.8,1.6-0.8,2.7c0,1,0.3,1.9,0.8,2.7
				c0.5,0.7,1.3,1.3,2.2,1.7c0.9,0.4,2,0.6,3.2,0.6c1.2,0,2.3-0.2,3.2-0.6C70.8,145.6,71.6,145,72.1,144.3z M68.2,141.7
				c0,1.6-0.5,2.4-1.6,2.4c-1.1,0-1.6-0.8-1.6-2.4c0-1.6,0.5-2.4,1.6-2.4C67.7,139.3,68.2,140.1,68.2,141.7z"/>
			<path id="XMLID_108_" className="bl2" d="M73.1,138.3c-0.7-0.9-1.6-1.6-2.7-2.1c-1.1-0.5-2.3-0.7-3.7-0.7c-1.4,0-2.6,0.2-3.7,0.7
				c-1.1,0.5-2.1,1.2-2.7,2.1c-0.2,0.3-0.4,0.6-0.5,1c-0.1-0.3-0.3-0.7-0.5-1c-0.7-0.9-1.6-1.6-2.7-2.1c-1.1-0.5-2.3-0.7-3.7-0.7
				c-1.4,0-2.6,0.2-3.7,0.7c-1.1,0.5-2.1,1.2-2.7,2.1c-0.1,0.2-0.2,0.3-0.3,0.5l0-1.9l0-1.2l-1.2,0l-7,0l-1.2,0l0,1.2l0,2.4l0,1.2
				l1.2,0l1.2,0l0,5.8l0,1.2l1.2,0l4.7,0l1.2,0l0-1.2l0-1.9c0.1,0.2,0.2,0.3,0.3,0.5c0.7,0.9,1.6,1.6,2.7,2.1
				c1.1,0.5,2.3,0.7,3.7,0.7c1.4,0,2.6-0.2,3.7-0.7c1.1-0.5,2.1-1.2,2.7-2.1c0.2-0.3,0.4-0.6,0.5-1c0.1,0.3,0.3,0.7,0.5,1
				c0.7,0.9,1.6,1.6,2.7,2.1c1.1,0.5,2.3,0.7,3.7,0.7c1.4,0,2.6-0.2,3.7-0.7c1.1-0.5,2.1-1.2,2.7-2.1c0.7-0.9,1-2.1,1-3.4
				C74.1,140.4,73.8,139.2,73.1,138.3z M66.6,146.6c-1.2,0-2.3-0.2-3.2-0.6c-0.9-0.4-1.7-1-2.2-1.7c-0.5-0.7-0.8-1.6-0.8-2.7
				c0-1,0.3-1.9,0.8-2.7c0.5-0.7,1.3-1.3,2.2-1.7c0.9-0.4,2-0.6,3.2-0.6c1.2,0,2.3,0.2,3.2,0.6c0.9,0.4,1.7,1,2.2,1.7
				c0.5,0.7,0.8,1.6,0.8,2.7c0,1-0.3,1.9-0.8,2.7c-0.5,0.7-1.3,1.3-2.2,1.7C68.9,146.4,67.9,146.6,66.6,146.6z M52.7,146.6
				c-1.2,0-2.3-0.2-3.2-0.6c-0.9-0.4-1.7-1-2.2-1.7c-0.5-0.7-0.8-1.6-0.8-2.7c0-1,0.3-1.9,0.8-2.7c0.5-0.7,1.3-1.3,2.2-1.7
				c0.9-0.4,2-0.6,3.2-0.6c1.2,0,2.3,0.2,3.2,0.6c0.9,0.4,1.7,1,2.2,1.7c0.5,0.7,0.8,1.6,0.8,2.7c0,1-0.3,1.9-0.8,2.7
				c-0.5,0.7-1.3,1.3-2.2,1.7C55,146.4,53.9,146.6,52.7,146.6z M37.7,136.9l7,0l0,9.4l-4.7,0l0-7l-2.4,0L37.7,136.9z"/>
			<path id="XMLID_44_" className="bl2" d="M65.1,141.7c0,1.6,0.5,2.4,1.6,2.4c1.1,0,1.6-0.8,1.6-2.4c0-1.6-0.5-2.4-1.6-2.4
				C65.6,139.3,65.1,140.1,65.1,141.7z"/>
		</g>
		<g id="XMLID_185_">
			<polygon id="XMLID_43_" className="bl1" points="315.9,146.5 320.6,146.6 320.6,137.1 313.5,137.1 313.5,139.5 315.9,139.5 			"/>
			<path id="XMLID_107_" className="bl1" d="M334,144.5c0.5-0.7,0.8-1.6,0.8-2.7c0-1-0.3-1.9-0.8-2.7c-0.5-0.7-1.3-1.3-2.2-1.7
				c-0.9-0.4-2-0.6-3.2-0.6c-1.2,0-2.3,0.2-3.2,0.6c-0.9,0.4-1.7,1-2.2,1.7c-0.5,0.7-0.8,1.6-0.8,2.7c0,1,0.3,1.9,0.8,2.7
				c0.5,0.7,1.3,1.3,2.2,1.7c0.9,0.4,2,0.6,3.2,0.6c1.2,0,2.3-0.2,3.2-0.6C332.7,145.8,333.4,145.2,334,144.5z M330.1,141.8
				c0,1.6-0.5,2.4-1.6,2.4c-1.1,0-1.6-0.8-1.6-2.4c0-1.6,0.5-2.4,1.6-2.4C329.6,139.4,330.1,140.2,330.1,141.8z"/>
			<path id="XMLID_40_" className="bl0" d="M326.9,141.8c0,1.6,0.5,2.4,1.6,2.4c1.1,0,1.6-0.8,1.6-2.4c0-1.6-0.5-2.4-1.6-2.4
				C327.5,139.4,326.9,140.2,326.9,141.8z"/>
			<path id="XMLID_106_" className="bl1" d="M347.9,144.5c0.5-0.7,0.8-1.6,0.8-2.7c0-1-0.3-1.9-0.8-2.7c-0.5-0.7-1.3-1.3-2.2-1.7
				c-0.9-0.4-2-0.6-3.2-0.6c-1.2,0-2.3,0.2-3.2,0.6c-0.9,0.4-1.7,1-2.2,1.7c-0.5,0.7-0.8,1.6-0.8,2.7c0,1,0.3,1.9,0.8,2.7
				c0.5,0.7,1.3,1.3,2.2,1.7c0.9,0.4,2,0.6,3.2,0.6c1.2,0,2.3-0.2,3.2-0.6C346.7,145.8,347.4,145.2,347.9,144.5z M344.1,141.8
				c0,1.6-0.5,2.4-1.6,2.4c-1.1,0-1.6-0.8-1.6-2.4c0-1.6,0.5-2.4,1.6-2.4C343.5,139.5,344.1,140.3,344.1,141.8z"/>
			<path id="XMLID_105_" className="bl0" d="M348.9,138.5c-0.7-0.9-1.6-1.6-2.7-2.1c-1.1-0.5-2.3-0.7-3.7-0.7c-1.4,0-2.6,0.2-3.7,0.7
				c-1.1,0.5-2.1,1.2-2.7,2.1c-0.2,0.3-0.4,0.6-0.5,1c-0.1-0.3-0.3-0.7-0.5-1c-0.7-0.9-1.6-1.6-2.7-2.1c-1.1-0.5-2.3-0.7-3.7-0.7
				c-1.4,0-2.6,0.2-3.7,0.7c-1.1,0.5-2.1,1.2-2.7,2.1c-0.1,0.2-0.2,0.3-0.3,0.5l0-1.9l0-1.2l-1.2,0l-7,0l-1.2,0l0,1.2l0,2.4l0,1.2
				l1.2,0l1.2,0l0,5.8l0,1.2l1.2,0l4.7,0l1.2,0l0-1.2l0-1.9c0.1,0.2,0.2,0.3,0.3,0.5c0.7,0.9,1.6,1.6,2.7,2.1
				c1.1,0.5,2.3,0.7,3.7,0.7c1.4,0,2.6-0.2,3.7-0.7c1.1-0.5,2.1-1.2,2.7-2.1c0.2-0.3,0.4-0.6,0.5-1c0.1,0.3,0.3,0.7,0.5,1
				c0.7,0.9,1.6,1.6,2.7,2.1c1.1,0.5,2.3,0.7,3.7,0.7c1.4,0,2.6-0.2,3.7-0.7c1.1-0.5,2.1-1.2,2.7-2.1c0.7-0.9,1-2.1,1-3.4
				C349.9,140.6,349.6,139.4,348.9,138.5z M339.2,146.2c-0.9-0.4-1.7-1-2.2-1.7c-0.5-0.7-0.8-1.6-0.8-2.7c0-1,0.3-1.9,0.8-2.7
				c0.5-0.7,1.3-1.3,2.2-1.7c0.9-0.4,2-0.6,3.2-0.6c1.2,0,2.3,0.2,3.2,0.6c0.9,0.4,1.7,1,2.2,1.7c0.5,0.7,0.8,1.6,0.8,2.7
				c0,1-0.3,1.9-0.8,2.7c-0.5,0.7-1.3,1.3-2.2,1.7c-0.9,0.4-2,0.6-3.2,0.6C341.3,146.8,340.2,146.6,339.2,146.2z M328.5,146.8
				c-1.2,0-2.3-0.2-3.2-0.6c-0.9-0.4-1.7-1-2.2-1.7c-0.5-0.7-0.8-1.6-0.8-2.7c0-1,0.3-1.9,0.8-2.7c0.5-0.7,1.3-1.3,2.2-1.7
				c0.9-0.4,2-0.6,3.2-0.6c1.2,0,2.3,0.2,3.2,0.6c0.9,0.4,1.7,1,2.2,1.7c0.5,0.7,0.8,1.6,0.8,2.7c0,1-0.3,1.9-0.8,2.7
				c-0.5,0.7-1.3,1.3-2.2,1.7C330.8,146.6,329.7,146.8,328.5,146.8z M313.5,137.1l7,0l0,9.4l-4.7,0l0-7l-2.4,0L313.5,137.1z"/>
			<path id="XMLID_33_" className="bl0" d="M340.9,141.8c0,1.6,0.5,2.4,1.6,2.4c1.1,0,1.6-0.8,1.6-2.4c0-1.6-0.5-2.4-1.6-2.4
				C341.4,139.5,340.9,140.3,340.9,141.8z"/>
		</g>
		<g id="XMLID_170_">
			<polygon id="XMLID_32_" className="bl1" points="40,263.7 44.6,263.7 44.6,254.2 37.6,254.2 37.6,256.6 40,256.6 			"/>
			<path id="XMLID_104_" className="bl1" d="M58,261.6c0.5-0.7,0.8-1.6,0.8-2.7c0-1-0.3-1.9-0.8-2.7c-0.5-0.7-1.3-1.3-2.2-1.7
				c-0.9-0.4-2-0.6-3.2-0.6c-1.2,0-2.3,0.2-3.2,0.6c-0.9,0.4-1.7,1-2.2,1.7c-0.5,0.7-0.8,1.6-0.8,2.7c0,1,0.3,1.9,0.8,2.7
				c0.5,0.7,1.3,1.3,2.2,1.7c0.9,0.4,2,0.6,3.2,0.6c1.2,0,2.3-0.2,3.2-0.6C56.8,262.9,57.5,262.3,58,261.6z M52.6,256.6
				c1.1,0,1.6,0.8,1.6,2.4c0,1.6-0.5,2.4-1.6,2.4c-1.1,0-1.6-0.8-1.6-2.4C51,257.4,51.5,256.6,52.6,256.6z"/>
			<path id="XMLID_29_" className="bl2" d="M52.6,261.3c1.1,0,1.6-0.8,1.6-2.4c0-1.6-0.5-2.4-1.6-2.4c-1.1,0-1.6,0.8-1.6,2.4
				C51,260.5,51.5,261.3,52.6,261.3z"/>
			<path id="XMLID_103_" className="bl1" d="M72,261.6c0.5-0.7,0.8-1.6,0.8-2.7c0-1-0.3-1.9-0.8-2.7c-0.5-0.7-1.3-1.3-2.2-1.7
				c-0.9-0.4-2-0.6-3.2-0.6c-1.2,0-2.3,0.2-3.2,0.6c-0.9,0.4-1.7,1-2.2,1.7c-0.5,0.7-0.8,1.6-0.8,2.7c0,1,0.3,1.9,0.8,2.7
				c0.5,0.7,1.3,1.3,2.2,1.7c0.9,0.4,2,0.6,3.2,0.6c1.2,0,2.3-0.2,3.2-0.6C70.7,262.9,71.5,262.4,72,261.6z M68.1,259
				c0,1.6-0.5,2.4-1.6,2.4c-1.1,0-1.6-0.8-1.6-2.4c0-1.6,0.5-2.4,1.6-2.4C67.6,256.6,68.1,257.4,68.1,259z"/>
			<path id="XMLID_102_" className="bl2" d="M73,255.6c-0.7-0.9-1.6-1.6-2.7-2.1c-1.1-0.5-2.3-0.7-3.7-0.7c-1.4,0-2.6,0.2-3.7,0.7
				c-1.1,0.5-2.1,1.2-2.7,2.1c-0.2,0.3-0.4,0.6-0.5,1c-0.1-0.3-0.3-0.7-0.5-1c-0.7-0.9-1.6-1.6-2.7-2.1c-1.1-0.5-2.3-0.7-3.7-0.7
				c-1.4,0-2.6,0.2-3.7,0.7c-1.1,0.5-2.1,1.2-2.7,2.1c-0.1,0.2-0.2,0.3-0.3,0.5l0-1.9l0-1.2l-1.2,0l-7,0l-1.2,0l0,1.2l0,2.4l0,1.2
				l1.2,0l1.2,0l0,5.8l0,1.2l1.2,0l4.7,0l1.2,0l0-1.2l0-1.9c0.1,0.2,0.2,0.3,0.3,0.5c0.7,0.9,1.6,1.6,2.7,2.1
				c1.1,0.5,2.3,0.7,3.7,0.7c1.4,0,2.6-0.2,3.7-0.7c1.1-0.5,2.1-1.2,2.7-2.1c0.2-0.3,0.4-0.6,0.5-1c0.1,0.3,0.3,0.7,0.5,1
				c0.7,0.9,1.6,1.6,2.7,2.1c1.1,0.5,2.3,0.7,3.7,0.7c1.4,0,2.6-0.2,3.7-0.7c1.1-0.5,2.1-1.2,2.7-2.1c0.7-0.9,1-2.1,1-3.4
				C74,257.7,73.7,256.6,73,255.6z M66.5,263.9c-1.2,0-2.3-0.2-3.2-0.6c-0.9-0.4-1.7-1-2.2-1.7c-0.5-0.7-0.8-1.6-0.8-2.7
				c0-1,0.3-1.9,0.8-2.7c0.5-0.7,1.3-1.3,2.2-1.7c0.9-0.4,2-0.6,3.2-0.6c1.2,0,2.3,0.2,3.2,0.6c0.9,0.4,1.7,1,2.2,1.7
				c0.5,0.7,0.8,1.6,0.8,2.7c0,1-0.3,1.9-0.8,2.7c-0.5,0.7-1.3,1.3-2.2,1.7C68.9,263.7,67.8,263.9,66.5,263.9z M52.6,263.9
				c-1.2,0-2.3-0.2-3.2-0.6c-0.9-0.4-1.7-1-2.2-1.7c-0.5-0.7-0.8-1.6-0.8-2.7c0-1,0.3-1.9,0.8-2.7c0.5-0.7,1.3-1.3,2.2-1.7
				c0.9-0.4,2-0.6,3.2-0.6c1.2,0,2.3,0.2,3.2,0.6c0.9,0.4,1.7,1,2.2,1.7c0.5,0.7,0.8,1.6,0.8,2.7c0,1-0.3,1.9-0.8,2.7
				c-0.5,0.7-1.3,1.3-2.2,1.7C54.9,263.7,53.8,263.9,52.6,263.9z M37.6,254.2l7,0l0,9.4l-4.7,0l0-7l-2.4,0L37.6,254.2z"/>
			<path id="XMLID_22_" className="bl2" d="M65,259c0,1.6,0.5,2.4,1.6,2.4c1.1,0,1.6-0.8,1.6-2.4c0-1.6-0.5-2.4-1.6-2.4
				C65.5,256.6,65,257.4,65,259z"/>
		</g>
		<g id="XMLID_157_">
			<g id="XMLID_168_">
				<polygon id="XMLID_21_" className="bl3" points="287.4,249.9 291.8,249.9 291.8,263 300.5,263 300.5,245.4 287.4,245.4 				"/>
			</g>
			<g id="XMLID_164_">
				<path id="XMLID_101_" className="bl3" d="M321.4,246.1c-1.8-0.7-3.8-1.1-6.1-1.1c-2.3,0-4.3,0.4-6.1,1.1c-1.8,0.7-3.1,1.8-4.1,3.2
					c-1,1.4-1.5,3-1.5,4.9c0,1.9,0.5,3.6,1.5,4.9c1,1.4,2.4,2.4,4.1,3.2c1.8,0.7,3.8,1.1,6.1,1.1c2.3,0,4.3-0.4,6.1-1.1
					c1.8-0.7,3.1-1.8,4.1-3.2c1-1.4,1.5-3,1.5-4.9c0-1.9-0.5-3.6-1.5-4.9C324.6,247.9,323.2,246.9,321.4,246.1z M315.4,258.7
					c-2,0-2.9-1.5-2.9-4.5c0-3,1-4.5,2.9-4.5c2,0,2.9,1.5,2.9,4.5C318.3,257.2,317.3,258.7,315.4,258.7z"/>
			</g>
			<g id="XMLID_160_">
				<path id="XMLID_100_" className="bl3" d="M351,249.3c-1-1.4-2.4-2.4-4.1-3.2c-1.8-0.7-3.8-1.1-6.1-1.1c-2.3,0-4.3,0.4-6.1,1.1
					c-1.8,0.7-3.1,1.8-4.1,3.2c-1,1.4-1.5,3-1.5,4.9c0,1.9,0.5,3.6,1.5,4.9c1,1.4,2.4,2.4,4.1,3.2c1.8,0.7,3.8,1.1,6.1,1.1
					c2.3,0,4.3-0.4,6.1-1.1c1.8-0.7,3.1-1.8,4.1-3.2c1-1.4,1.5-3,1.5-4.9C352.5,252.3,352,250.7,351,249.3z M340.8,258.7
					c-2,0-2.9-1.5-2.9-4.5c0-3,1-4.5,2.9-4.5c2,0,2.9,1.5,2.9,4.5C343.8,257.2,342.8,258.7,340.8,258.7z"/>
			</g>
			<g id="XMLID_158_">
				<path id="XMLID_16_" className="bl3" d="M269.2,226.6L269.2,226.6c1,0,1.7-0.8,1.7-1.7l0-1.5c0-1-0.8-1.7-1.7-1.7l-27.2,0
					c-1,0-1.7,0.8-1.7,1.7l0,1.5c0,1,0.8,1.7,1.7,1.7h0c1.2,0,2,1.1,1.7,2.2c-0.7,2.4-2.2,5.1-5,6.6c-0.6,0.3-0.9,0.9-0.9,1.5
					l0,15.6c0,1,0.8,1.7,1.7,1.7l16.1,0l16.1,0c1,0,1.7-0.8,1.7-1.7l0-15.6c0-0.6-0.3-1.2-0.9-1.5c-2.8-1.5-4.3-4.2-5-6.6
					C267.2,227.7,268.1,226.6,269.2,226.6z"/>
			</g>
		</g>
		<g id="XMLID_152_">
			<g id="XMLID_155_">
				<path id="XMLID_15_" className="bl3" d="M285.7,231.4l0,5.5c0,1,0.8,1.7,1.7,1.7l65.9,0c1,0,1.7-0.8,1.7-1.7l0-5.5
					c0-1-0.8-1.7-1.7-1.7l-65.9,0C286.5,229.7,285.7,230.5,285.7,231.4z"/>
			</g>
			<g id="XMLID_153_">
				<path id="XMLID_14_" className="bl0" d="M38.1,163.8l0,5.5c0,1,0.8,1.7,1.7,1.7l65.9,0c1,0,1.7-0.8,1.7-1.7l0-5.5
					c0-1-0.8-1.7-1.7-1.7l-65.9,0C38.9,162.1,38.1,162.8,38.1,163.8z"/>
			</g>
		</g>
		<g id="XMLID_145_">
			<g id="XMLID_150_">
				<path id="XMLID_13_" className="bl3" d="M268,144.4l-24.6,0c-1,0-1.7,0.8-1.7,1.7l0,2.3c0,1,0.8,1.7,1.7,1.7l24.6,0
					c1,0,1.7-0.8,1.7-1.7l0-2.3C269.7,145.2,268.9,144.4,268,144.4z"/>
			</g>
			<g id="XMLID_148_">
				<path id="XMLID_12_" className="bl3" d="M211,154l0,8.9c0,1,0.8,1.7,1.7,1.7l85.9,0.1c1,0,1.7-0.8,1.7-1.7l0-8.9
					c0-1-0.8-1.7-1.7-1.7l-85.9-0.1C211.8,152.3,211,153.1,211,154z"/>
			</g>
			<g id="XMLID_146_">
				<path id="XMLID_11_" className="bl3" d="M221.1,179.2l69.1,0c1,0,1.7-0.8,1.7-1.7l0-8.9c0-1-0.8-1.7-1.7-1.7l-69.1,0
					c-1,0-1.7,0.8-1.7,1.7l0,8.9C219.4,178.5,220.1,179.2,221.1,179.2z"/>
			</g>
		</g>
		<g id="XMLID_142_">
			<g id="XMLID_143_">
				<path id="XMLID_10_" className="bl0" d="M117.5,153.2l-77.7-0.1c-1,0-1.7,0.8-1.7,1.7v0c0,1,0.8,1.7,1.7,1.7l77.7,0.1
					c1,0,1.7-0.8,1.7-1.7v0C119.3,154,118.5,153.2,117.5,153.2z"/>
			</g>
		</g>
		<g id="XMLID_139_">
			<g id="XMLID_140_">
				<path id="XMLID_9_" className="bl0" d="M82.6,240l-42.8,0c-1,0-1.7,0.8-1.7,1.7v0c0,1,0.8,1.7,1.7,1.7l42.8,0c1,0,1.7-0.8,1.7-1.7v0
					C84.3,240.7,83.6,240,82.6,240z"/>
			</g>
		</g>
		<g id="XMLID_136_">
			<g id="XMLID_137_">
				<path id="XMLID_8_" className="bl0" d="M82.6,228.7l-42.8,0c-1,0-1.7,0.8-1.7,1.7v0c0,1,0.8,1.7,1.7,1.7l42.8,0c1,0,1.7-0.8,1.7-1.7
					l0,0C84.4,229.5,83.6,228.7,82.6,228.7z"/>
			</g>
		</g>
		<g id="XMLID_123_">
			<g id="XMLID_134_">
				<path id="XMLID_187_" className="bl2" d="M149.8,140.5c-9.5,1.4-17.9,8.6-20.7,18l-11.2,38.3c-3.1,10.6,3.1,21.8,13.8,24.7l17.7,4.9
					L149.8,140.5z"/>
				<path id="XMLID_189_" className="bl3" d="M212.4,196.5l-11.2-38.3c-3.1-10.7-12.9-18-24-18l-12.3,0l-0.1,0l-12.3,0
					c-0.9,0-1.3,0-2.2,0.1l-0.5,86.1l15,4.2v0l0,0l0,0v0l33.8-9.3C209.3,218.3,215.5,207.2,212.4,196.5z"/>
			</g>
			<g id="XMLID_132_">
				<path id="XMLID_184_" className="bl3" d="M149.8,259.2l72.3,0.1c0-23.6-19.1-42.8-42.8-42.8l-29,0c-0.2,0-0.4,0-0.6,0V259.2z"/>
				<path id="XMLID_191_" className="bl2" d="M149.5,216.4c-23.3,0.8-41.9,19.6-41.9,42.7l41.9,0V216.4z"/>
			</g>
			<g id="XMLID_130_">
				<path id="XMLID_193_" className="bl3" d="M149.8,203.1v31.5c3,8.2,10.9,14.1,20.1,14.2l11.3,0l0-45.6L149.8,203.1z"/>
			</g>
			<g id="XMLID_128_">
				<path id="XMLID_180_" className="bl0" d="M150.2,203.1v19.6c4.5,2.4,9.5,3.7,14.9,3.7c5.9,0,11.4-1.6,16.2-4.4l0-18.9L150.2,203.1z"
					/>
			</g>
			<g id="XMLID_126_">
				<path id="XMLID_178_" className="bl4" d="M149.3,152c-6.1,4.8-10.5,13-10.5,21.3l0,20.3c0,8.3,4.4,16.2,10.5,21L149.3,152z"/>
				<path id="XMLID_324_" className="bl3" d="M164.9,147.2L164.9,147.2c-5.6,0-10.9,1.8-15.1,4.8v62.9c4.3,3,9.5,4.8,15.1,4.8l0,0
					c14.4,0,26.1-11.7,26.1-26.1l0-20.3C191,158.9,179.4,147.2,164.9,147.2z"/>
			</g>
			<g id="XMLID_124_">
				<path id="XMLID_176_" className="bl0" d="M148.8,172.2c-0.6,0.3-1,0.9-1,1.6c0,0.7,0.4,1.3,1,1.6V172.2z"/>
				<path id="XMLID_325_" className="bl0" d="M172.4,191.3l-5.7,0l0-13c0-3.5-2.8-6.3-6.3-6.3l-10.6,0v3.6l10.6,0c1.5,0,2.7,1.2,2.7,2.7
					l0,14.8c0,1,0.8,1.8,1.8,1.8l7.5,0c1,0,1.8-0.8,1.8-1.8C174.2,192.1,173.4,191.3,172.4,191.3z"/>
			</g>
		</g>
		<g id="XMLID_120_">
			<g id="XMLID_121_">
				<rect id="XMLID_1_" x="184.8" y="134.9" className="bl1" width="115.6" height="3.5"/>
			</g>
		</g>
	</g>
</g>
<line id="XMLID_263_" className="bl5" x1="49.5" y1="112" x2="49.5" y2="310"/>
<line id="XMLID_266_" className="bl5" x1="249.5" y1="112" x2="249.5" y2="310"/>
<radialGradient id="XMLID_65_" cx="149.5" cy="205" r="65.7619" gradientUnits="userSpaceOnUse">
	<stop  offset="0" className="nice"/>
	<stop  offset="1" className="nice2"/>
</radialGradient>
<line id="XMLID_3_" className="bl6" x1="149.5" y1="112" x2="149.5" y2="310"/>
<line id="XMLID_267_" className="bl5" x1="349.5" y1="112" x2="349.5" y2="310"/>
<text id="XMLID_2_" transform="matrix(4.489659e-11 -1 1 4.489659e-11 57.8487 306)" className="bl7 bl8">{today}</text>
<text id="XMLID_5_" transform="matrix(4.489659e-11 -1 1 4.489659e-11 158.0959 306)" className="bl7 bl8">{tomorrow}</text>
<text id="XMLID_6_" transform="matrix(4.489659e-11 -1 1 4.489659e-11 258.343 306)" className="bl0 bl7 bl8">{tomo}</text>
<text id="XMLID_7_" transform="matrix(4.489659e-11 -1 1 4.489659e-11 357.773 306)" className="bl0 bl7 bl8">{tomo2}</text></svg>

            <div className="timeline-descr">
                <h4><Translate>Installments</Translate></h4>
                <p><Translate>Payment must be made monthly, starting from the date specified in the installment agreement, similar to car leasing.</Translate></p>
            </div>
            </div>
        </div>
      </div>
		 <div className="forge-item-descr ">
        <div className="row">
            <div className="item-descr-tl">
<img className="img-timeline" src={Receipt} />

            <div className="timeline-descr">
                <h4><Translate>Partnership</Translate></h4>
                <p><Translate>In this case, we provide you with a complete toolkit for promoting your project, such as developing a marketing plan specifically for your business, developing a web application according to all modern requirements, developing a brand book and corporate identity, as well as setting up effective advertising.</Translate></p>
            </div>
            </div>
        </div>
      </div>
           <Advantages />
           <About />
           <Footer />
     </div>
    );
  }
}


export default PaymentTypes;



// WEBPACK FOOTER //
// ./src/components/CompanyPages/PaymentTypes/index.js